export default "__VITE_ASSET__06ae4ea7__"